module.exports = __webpack_public_path__ + "img/old-portfolio.83e8c583.png";